{
  "generic": "Une erreur est survenue",
  "networkError": "Erreur r\u00e9seau - veuillez v\u00e9rifier votre connexion",
  "unauthorized": "Vous n\u2019\u00eates pas autoris\u00e9 \u00e0 effectuer cette action",
  "notFound": "La ressource demand\u00e9e est introuvable",
  "serverError": "Erreur serveur - veuillez r\u00e9essayer plus tard",
  "validationError": "Veuillez v\u00e9rifier votre saisie",
  "uploadFailed": "\u00c9chec du t\u00e9l\u00e9versement",
  "uploadSuccess_one": "{{count}} fichier charg\u00e9 avec succ\u00e8s",
  "uploadSuccess_other": "{{count}} fichiers charg\u00e9s avec succ\u00e8s",
  "invalidFileType": "Type de fichier non valide",
  "fileTooLarge": "Le fichier est trop volumineux",
  "sessionExpired": "Votre session a expir\u00e9. Veuillez vous reconnecter.",
  "loadAgentsFailed": "Impossible de charger les agents",
  "loadProfileFailed": "Impossible de charger le profil utilisateur",
  "stream": {
    "hitl_question_undelivered": "Nous n'avons pas pu transmettre la question de l'assistant. Cette mission est peut-\u00eatre toujours en cours.",
    "subscription_forbidden": "Vous n'avez pas accès à cette exécution.",
    "subscription_unavailable": "Les mises à jour en direct de cette exécution sont indisponibles pour le moment. Veuillez réessayer.",
    "control_forbidden": "Vous ne pouvez pas agir sur cette exécution.",
    "control_unavailable": "Cette exécution ne peut pas être arrêtée, mise en pause ou reprise pour le moment. Réessayez dans un instant.",
    "conversation_not_viewable": "Cette conversation appartient à une autre personne. Elle seule peut la lire ici."
  }
}
